/* eslint-disable import/no-anonymous-default-export */
import { FundShow } from './FundShow';
import { FundList } from './FundList';
import { FundEdit } from './FundEdit';
//import { ContactCreate } from './ContactCreate';
import { Fund } from '../../types/types';

export default {
    list: FundList,
    show: FundShow,
    edit: FundEdit,
    //create: ContactCreate,
    recordRepresentation: (record: Fund) =>
        record?.name,
};
